module.exports = __webpack_public_path__ + "img/paper_upload.1b902fa8.svg";